import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/station';

const options = {
  cache: {
      maxAge: 15 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadStations = async ({organization_ids, station_ids, stationtypes_ids}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, {organization_ids, station_ids, stationtypes_ids});
  return api.get(url, options);
}

const loadStationsById = async (id) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(`${END_POINT}/${id}`, options);
}

export {
  loadStations,
  loadStationsById
}
